<template>
  <div class="rating-badge" :class="`rating-badge--${position.replace(' ', '-')}`">
    {{ rating }}
    <span />
  </div>
</template>

<script setup lang="ts">
defineOptions({
  name: "rating-badge",
});

defineProps({
  rating: {
    type: Number,
    required: true,
  },
  position: {
    type: String,
    required: false,
    default: "top left",
    validator: (value: string) => ["top left", "top right", "bottom left", "bottom right"].includes(value),
  },
});
</script>

<style scoped lang="scss">
@import "./index.scss";
</style>
